import { Injectable, EventEmitter } from '@angular/core';

@Injectable()
export class LoaderService {
  loadingContent: EventEmitter<boolean> = new EventEmitter<boolean>();
}
